import React from 'react';
import { FaYoutube, FaGoogle, FaFacebook, FaWeibo, FaWhatsapp, FaGithub, FaFigma, FaAndroid, FaPinterest, FaPaypal, FaInstagram, FaKickstarter, FaApple, FaTumblr, FaPlaystation, FaSpotify, FaStackOverflow } from "react-icons/fa";

const Icon = [
  <FaYoutube size={24} />,
  <FaGoogle size={24} />,
  <FaFacebook size={24} />,
  <FaWeibo size={24} />,
  <FaWhatsapp size={24} />,
  <FaGithub size={24} />,
  <FaFigma size={24} />,
  <FaAndroid size={24} />,
  <FaPinterest size={24} />,
  <FaPaypal size={24} />,
  <FaInstagram size={24} />,
  <FaKickstarter size={24} />,
  <FaApple size={24} />,
  <FaTumblr size={24} />,
  <FaPlaystation size={24} />,
  <FaSpotify size={24} />,
  <FaStackOverflow size={24} />
]

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

shuffleArray(Icon);

export default Icon